import { render, staticRenderFns } from "./RightStructure.vue?vue&type=template&id=d66caa3a"
import script from "./RightStructure.vue?vue&type=script&lang=js"
export * from "./RightStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports